var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHistory(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 96 96",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Location"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 38.5,
    cy: 45.5,
    r: 1.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 38.5,
    cy: 36.5,
    r: 1.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 38.5,
    cy: 27.5,
    r: 1.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 38.5,
    cy: 54.5,
    r: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78,31.5A14.51,14.51,0,0,0,63.5,17h-28A8.51,8.51,0,0,0,27,25.5V63H24.5a8.5,8.5,0,0,0,0,17h36A8.51,8.51,0,0,0,69,71.5V44.91A14.52,14.52,0,0,0,78,31.5ZM24.5,79a7.5,7.5,0,0,1,0-15h32a8.49,8.49,0,0,0,0,15ZM68,71.5A7.5,7.5,0,1,1,60.5,64H68Zm.23-27.37c-.35.13-.7.25-1,.35l-.18,0c-.33.09-.67.17-1,.24l-.46.07-.76.11c-.42,0-.85.06-1.28.06a13.48,13.48,0,0,1-12.77-9.16.51.51,0,0,0-.64-.31.5.5,0,0,0-.31.63A14.51,14.51,0,0,0,58.23,45H43.5a.5.5,0,0,0,0,1h16a.5.5,0,0,0,.49-.44A14.13,14.13,0,0,0,63.5,46c.44,0,.87,0,1.31-.07.18,0,.36,0,.54-.06l.69-.11.72-.14.39-.1c.28-.08.57-.15.85-.24V63H28V25.5A7.5,7.5,0,0,1,35.5,18H58.23l-.06,0-.22.09c-.3.13-.6.26-.89.41l-.34.18-.78.44-.28.18c-.33.22-.66.44-1,.69l-.15.12c-.26.21-.52.43-.77.66l-.27.25c-.21.21-.42.42-.62.64a2.73,2.73,0,0,0-.23.25c-.27.3-.52.61-.76.93L51.8,23c-.21.28-.41.58-.6.88l-.19.32c-.15.26-.29.52-.43.78s-.11.21-.16.32c-.17.36-.34.73-.48,1.12l0,.08c-.13.36-.24.72-.35,1.09l-.09.36c-.08.3-.14.6-.2.9,0,0,0,0,0,.06L48,26.28a.5.5,0,1,0-.9.44l2,4s0,0,0,0l0,.05a.25.25,0,0,0,.1.08l.06.05a.55.55,0,0,0,.24.07h0a.5.5,0,0,0,.41-.2l3.87-2.9a.5.5,0,0,0,.1-.7.51.51,0,0,0-.7-.1l-3,2.26a13.49,13.49,0,1,1,18,14.77Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63,33.26V23.5a.5.5,0,0,0-1,0v10a0,0,0,0,0,0,0,.44.44,0,0,0,0,.1.19.19,0,0,0,0,.08l.05.08a.27.27,0,0,0,.07.08l0,0,5,4a.51.51,0,0,0,.31.11.48.48,0,0,0,.39-.19.5.5,0,0,0-.08-.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.5,36h-4a.5.5,0,0,0,0,1h4a.5.5,0,0,0,0-1Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.5,28h2a.5.5,0,0,0,0-1h-2a.5.5,0,0,0,0,1Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.5,55h16a.5.5,0,0,0,0-1h-16a.5.5,0,0,0,0,1Z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHistory);
export default __webpack_public_path__ + "static/media/history.d89eb8e5daa01f3cdc76afc29572c764.svg";
export { ForwardRef as ReactComponent };